<script lang="ts">
	import { MediaGallery } from '@wiseed/wikit';
	import type { MediaGalleryItem } from '@wiseed/wikit';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { t } from 'svelte-i18n';
	import { capitalize } from '@wiseed/wikit';
	import { getEmbedVideoUrl } from '@app/utils/videos';
	import AppAdaptiveVideo from '@app/components/AppAdaptiveVideo.svelte';
	export let operation: OperationModel;

	let medias: MediaGalleryItem[] = operation.images;
	let embedVideoUrl: string | undefined;

	$: hasVideo = operation.idVideoEmbed !== undefined && operation.typeVideoEmbed !== undefined;
	$: if (hasVideo) {
		embedVideoUrl = getEmbedVideoUrl(operation.idVideoEmbed, operation.typeVideoEmbed);
		embedVideoUrl &&
			(medias = [
				...(medias ? medias : []),
				{
					title: '',
					url: embedVideoUrl,
					isVideo: true
				}
			]);
	}
</script>

{#if (operation.images && operation.images.length) || hasVideo}
	<section>
		<h2>{capitalize($t('operation.photoGallery'))}</h2>
		{#if operation.images && operation.images.length}
			<MediaGallery {medias} />
		{/if}
		{#if !operation.images && hasVideo && embedVideoUrl}
			<AppAdaptiveVideo
				src={embedVideoUrl}
				iframeTitle={$t('operation.videoTitle')}
				ratio="aspect-video"
				iframe={true}
			/>
		{/if}
	</section>
{/if}
